import { z } from 'zod';

export const ReputationSearchFormSchema = z.object({
  search: z.string().nullable(),
});

export type ReputationSearch = z.infer<typeof ReputationSearchFormSchema>;
